import { initUtilisateur, UserFormData } from 'core/models';
import { createContext, useContext, useState } from 'react';

const UserSelectedContext = createContext<any>({
    selectedUser: '',
    setSelectedUser: () => {},
    isFormSubmitted: '',
    setIsFormSubmitted: () => {},
    isFormSuccess: '',
    setIsFormSuccess: () => {},
    isDrawerLocked: '',
    setIsDrawerLocked: () => {},
    userConnected: '',
    setUserConnected: () => {},
    isValidatedLogin: '',
    setIsCheckingLogin: () => {},
    isLoadingUser: '',
    setIsLoadingUser: () => {},
    isCheckingEmail: '',
    setIsCheckingEmail: () => {},
    isValidatedEmail: '',
    setIsValidatedEmail: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function UtilisateurFormProvider({ children }: Props) {
    const [selectedUser, setSelectedUser] = useState<UserFormData>(initUtilisateur());
    const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
    const [isFormSuccess, setIsFormSuccess] = useState<boolean>(false);
    const [isDrawerLocked, setIsDrawerLocked] = useState<boolean>(false);
    const [userConnected, setUserConnected] = useState(false);
    const [isCheckingLogin, setIsCheckingLogin] = useState(false);
    const [isValidatedLogin, setIsValidatedLogin] = useState(false);
    const [isLoadingUser, setIsLoadingUser] = useState(false);
    const [isCheckingEmail, setIsCheckingEmail] = useState(false);
    const [isValidatedEmail, setIsValidatedEmail] = useState(false);

    return (
        <UserSelectedContext.Provider
            value={{
                selectedUser,
                setSelectedUser,
                isFormSubmitted,
                setIsFormSubmitted,
                isFormSuccess,
                setIsFormSuccess,
                isDrawerLocked,
                setIsDrawerLocked,
                userConnected,
                setUserConnected,
                isCheckingLogin,
                setIsCheckingLogin,
                isValidatedLogin,
                setIsValidatedLogin,
                isLoadingUser,
                setIsLoadingUser,
                isCheckingEmail,
                setIsCheckingEmail,
                isValidatedEmail,
                setIsValidatedEmail,
            }}
        >
            {children}
        </UserSelectedContext.Provider>
    );
}

export const useUtilisateurFromContext = () => useContext(UserSelectedContext);
